<div class="pagination-container">
    <div class="pagination-settings">
        <label for="page-size-select">Registros por página:</label>
        <select id="page-size-select" (change)="onPageSizeChange($event)" [value]="pageSize">
            <option *ngFor="let size of [5, 10, 20, 50]" [value]="size">{{ size }}</option>
        </select>
    </div>

    <div class="pagination-controls">
        <button (click)="goToPreviousPage()" [disabled]="currentPage === 1">
            Anterior
        </button>
        <span>
            Página {{ currentPage }} de {{ totalPages }}
        </span>
        <button (click)="goToNextPage()" [disabled]="currentPage >= totalPages">
            Siguiente
        </button>
    </div>
</div>